import styled from 'styled-components';
export const LoginButton = styled.button.withConfig({ displayName: "vui--LoginButton", componentId: "vui--9ns5xb" }) `background:none;border:none;padding:0;cursor:pointer;img{width:156px;height:32px;}`;
//# sourceMappingURL=styled.js.map